import ip11 from '../assets/models/SPOKE_ToughCases_Template_iPhone_11.png';
import ip11Pro from '../assets/models/SPOKE_ToughCases_Template_iPhone_11_Pro.png';
import ip11ProMax from '../assets/models/SPOKE_ToughCases_Template_iPhone_11_Pro_Max.png';
import ip12Pro from '../assets/models/SPOKE_ToughCases_Template_iPhone_12_12_Pro.png';
import ip12Mini from '../assets/models/SPOKE_ToughCases_Template_iPhone_12_Mini.png';
import ip12ProMax from '../assets/models/SPOKE_ToughCases_Template_iPhone_12_Pro_Max.png';
import ip13 from '../assets/models/SPOKE_ToughCases_Template_iPhone_13.png';
import ip13Mini from '../assets/models/SPOKE_ToughCases_Template_iPhone_13_Mini.png';
import ip13Pro from '../assets/models/SPOKE_ToughCases_Template_iPhone_13_Pro.png';
import ip13ProMax from '../assets/models/SPOKE_ToughCases_Template_iPhone_13_Pro_Max.png';
import ip14 from '../assets/models/SPOKE_ToughCases_Template_iPhone_14.png';
import ip14Plus from '../assets/models/SPOKE_ToughCases_Template_iPhone_14_Plus.png';
import ip14Pro from '../assets/models/SPOKE_ToughCases_Template_iPhone_14_Pro.png';
import ip14ProMax from '../assets/models/SPOKE_ToughCases_Template_iPhone_14_Pro_Max.png';
import ip15 from '../assets/models/SPOKE_ToughCases_Template_iPhone_15.png';
import ip15Plus from '../assets/models/SPOKE_ToughCases_Template_iPhone_15_Plus.png';
import ip15Pro from '../assets/models/SPOKE_ToughCases_Template_iPhone_15_Pro.png';
import ip15ProMax from '../assets/models/SPOKE_ToughCases_Template_iPhone_15_Pro_Max.png';
import ipX from '../assets/models/SPOKE_ToughCases_Template_iPhone_X.png';
import ipXR from '../assets/models/SPOKE_ToughCases_Template_iPhone_XR.png';
import ipXS from '../assets/models/SPOKE_ToughCases_Template_iPhone_XS.png';
import ipXSMax from '../assets/models/SPOKE_ToughCases_Template_iPhone_XS_MAX.png';
import ip12 from '../assets/models/template_iphone_12.png';
import ip16 from '../assets/models/template_iphone_16.png';
import ip16Plus from '../assets/models/template_iphone_16_plus.png';
import ip16Pro from '../assets/models/template_iphone_16_pro.png';
import ip16ProMax from '../assets/models/template_iphone_16_pro_max.png';
import { PhoneCaseModel } from '../interfaces/Phone';

export const PHONE_CASE_MODELS = [
  {
    label: 'Iphone 11',
    value: PhoneCaseModel.Iphone11,
    model: ip11,
  },
  {
    label: 'Iphone 11 Pro',
    value: PhoneCaseModel.Iphone11Pro,
    model: ip11Pro,
  },
  {
    label: 'Iphone 11 Pro Max',
    value: PhoneCaseModel.Iphone11ProMax,
    model: ip11ProMax,
  },
  {
    label: 'Iphone 12',
    value: PhoneCaseModel.Iphone12,
    model: ip12,
  },
  {
    label: 'Iphone 12 Pro',
    value: PhoneCaseModel.Iphone12Pro,
    model: ip12Pro,
  },
  {
    label: 'Iphone 12 Pro Max',
    value: PhoneCaseModel.Iphone12ProMax,
    model: ip12ProMax,
  },
  {
    label: 'Iphone 12 Mini',
    value: PhoneCaseModel.Iphone12Mini,
    model: ip12Mini,
  },
  {
    label: 'Iphone 13',
    value: PhoneCaseModel.Iphone13,
    model: ip13,
  },
  {
    label: 'Iphone 13 Pro',
    value: PhoneCaseModel.Iphone13Pro,
    model: ip13Pro,
  },
  {
    label: 'Iphone 13 Pro Max',
    value: PhoneCaseModel.Iphone13ProMax,
    model: ip13ProMax,
  },
  {
    label: 'Iphone 13 Mini',
    value: PhoneCaseModel.Iphone13Mini,
    model: ip13Mini,
  },
  {
    label: 'Iphone 14',
    value: PhoneCaseModel.Iphone14,
    model: ip14,
  },
  {
    label: 'Iphone 14 Plus',
    value: PhoneCaseModel.Iphone14Plus,
    model: ip14Plus,
  },
  {
    label: 'Iphone 14 Pro',
    value: PhoneCaseModel.Iphone14Pro,
    model: ip14Pro,
  },
  {
    label: 'Iphone 14 Pro Max',
    value: PhoneCaseModel.Iphone14ProMax,
    model: ip14ProMax,
  },
  {
    label: 'Iphone 15',
    value: PhoneCaseModel.Iphone15,
    model: ip15,
  },
  {
    label: 'Iphone 15 Plus',
    value: PhoneCaseModel.Iphone15Plus,
    model: ip15Plus,
  },
  {
    label: 'Iphone 15 Pro',
    value: PhoneCaseModel.Iphone15Pro,
    model: ip15Pro,
  },
  {
    label: 'Iphone 15 Pro Max',
    value: PhoneCaseModel.Iphone15ProMax,
    model: ip15ProMax,
  },
  {
    label: 'Iphone 16',
    value: PhoneCaseModel.Iphone16,
    model: ip16,
  },
  {
    label: 'Iphone 16 Plus',
    value: PhoneCaseModel.Iphone16Plus,
    model: ip16Plus,
  },
  {
    label: 'Iphone 16 Pro',
    value: PhoneCaseModel.Iphone16Pro,
    model: ip16Pro,
  },
  {
    label: 'Iphone 16 Pro Max',
    value: PhoneCaseModel.Iphone16ProMax,
    model: ip16ProMax,
  },
  {
    label: 'Iphone X',
    value: PhoneCaseModel.IphoneX,
    model: ipX,
  },
  {
    label: 'Iphone XR',
    value: PhoneCaseModel.IphoneXR,
    model: ipXR,
  },
  {
    label: 'Iphone XS',
    value: PhoneCaseModel.IphoneXS,
    model: ipXS,
  },
  {
    label: 'Iphone XS Max',
    value: PhoneCaseModel.IphoneXSMax,
    model: ipXSMax,
  },
];

export const INITIAL_ZOOM = 0.3;

export const DEFAULT_PX_TO_MM_DPI = 11.811023622;
